var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 27"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 107",
    cx: 30.2459,
    cy: 30.5,
    r: 29.7459,
    stroke: "url(#paint0_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.58 29.0805C33.0942 29.0805 35.1396 27.0353 35.1396 24.521C35.1396 22.0066 33.0944 19.9614 30.58 19.9614C28.0657 19.9614 26.0205 22.0066 26.0205 24.521C26.0205 27.0353 28.0657 29.0805 30.58 29.0805ZM30.58 21.2645C32.3777 21.2645 33.8367 22.7235 33.8367 24.5212C33.8367 26.3188 32.3777 27.7778 30.58 27.7778C28.7824 27.7778 27.3234 26.3188 27.3234 24.5212C27.3234 22.7235 28.7824 21.2645 30.58 21.2645Z",
    fill: "url(#paint1_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.5794 31.0347C25.9094 31.0347 22.1123 34.8319 22.1123 39.5018C22.1123 39.86 22.4054 40.1531 22.7636 40.1531C23.1219 40.1531 23.415 39.86 23.415 39.5018C23.415 35.5482 26.626 32.3369 30.5798 32.3369C34.5336 32.3369 37.7447 35.548 37.7447 39.5018C37.7447 39.86 38.0378 40.1531 38.396 40.1531C38.7543 40.1531 39.0474 39.86 39.0474 39.5018C39.0474 34.8318 35.2501 31.0347 30.5803 31.0347H30.5794Z",
    fill: "url(#paint2_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.158 30.1361C22.3139 30.1361 24.066 28.384 24.066 26.2281C24.066 24.0721 22.3139 22.3201 20.158 22.3201C18.0021 22.3201 16.25 24.0721 16.25 26.2281C16.25 28.384 18.0021 30.1361 20.158 30.1361ZM20.158 23.6227C21.5974 23.6227 22.7633 24.7886 22.7633 26.2281C22.7633 27.6675 21.5974 28.8334 20.158 28.8334C18.7186 28.8334 17.5527 27.6675 17.5527 26.2281C17.5527 24.7886 18.7186 23.6227 20.158 23.6227Z",
    fill: "url(#paint3_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.1479 32.891C23.2782 32.5589 23.1154 32.1811 22.7832 32.0443C21.9495 31.7187 21.0637 31.5493 20.1649 31.5493C16.2113 31.5493 13 34.7604 13 38.7142C13 39.0724 13.2931 39.3655 13.6513 39.3655C14.0096 39.3655 14.3027 39.0724 14.3027 38.7142C14.3027 35.4836 16.934 32.8524 20.1644 32.8524C20.9069 32.8524 21.6234 32.9892 22.3073 33.2562C22.6395 33.3865 23.0173 33.2237 23.154 32.8915L23.1479 32.891Z",
    fill: "url(#paint4_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.0008 30.1361C43.1567 30.1361 44.9088 28.384 44.9088 26.2281C44.9088 24.0721 43.1567 22.3201 41.0008 22.3201C38.8448 22.3201 37.0928 24.0721 37.0928 26.2281C37.0928 28.384 38.8448 30.1361 41.0008 30.1361ZM41.0008 23.6227C42.4402 23.6227 43.6061 24.7886 43.6061 26.2281C43.6061 27.6675 42.4402 28.8334 41.0008 28.8334C39.5613 28.8334 38.3954 27.6675 38.3954 26.2281C38.3954 24.7886 39.5613 23.6227 41.0008 23.6227Z",
    fill: "url(#paint5_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.0014 31.549C40.096 31.549 39.2167 31.7184 38.383 32.044C38.0508 32.1743 37.8815 32.5521 38.0183 32.8907C38.1485 33.2229 38.5263 33.3923 38.865 33.2555C39.5489 32.9884 40.2654 32.8517 41.0079 32.8517C44.2385 32.8517 46.8696 35.4831 46.8696 38.7135C46.8696 39.0717 47.1627 39.3648 47.521 39.3648C47.8792 39.3648 48.1723 39.0717 48.1723 38.7135C48.1723 34.7599 44.9612 31.5486 41.0074 31.5486L41.0014 31.549Z",
    fill: "url(#paint6_linear_844_15782)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 108",
    cx: 54,
    cy: 54.7461,
    r: 12,
    fill: "url(#paint7_linear_844_15782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M58.5532 49.6385C57.6908 48.7761 56.2927 48.7761 55.4303 49.6385L55.2568 49.812L58.3797 52.9348L58.5532 52.7613C59.4155 51.899 59.4155 50.5008 58.5532 49.6385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.0117 56.0581L54.5635 50.5063L57.6863 53.6292L52.1346 59.1809L49.0117 56.0581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M48.4835 56.918L48.0075 59.6157C47.9796 59.7734 48.0305 59.9347 48.1437 60.048C48.257 60.1612 48.4183 60.2121 48.576 60.1842L51.2737 59.7082L48.4835 56.918Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_844_15782",
    x1: 30.2459,
    y1: 0.25415,
    x2: 30.2459,
    y2: 60.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_844_15782",
    x1: 30.58,
    y1: 19.9614,
    x2: 30.58,
    y2: 29.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_844_15782",
    x1: 30.5798,
    y1: 31.0347,
    x2: 30.5798,
    y2: 40.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_844_15782",
    x1: 20.158,
    y1: 22.3201,
    x2: 20.158,
    y2: 30.1361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_844_15782",
    x1: 18.0964,
    y1: 31.5493,
    x2: 18.0964,
    y2: 39.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_844_15782",
    x1: 41.0008,
    y1: 22.3201,
    x2: 41.0008,
    y2: 30.1361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_844_15782",
    x1: 43.0715,
    y1: 31.5486,
    x2: 43.0715,
    y2: 39.3648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_844_15782",
    x1: 54,
    y1: 42.7461,
    x2: 54,
    y2: 66.7461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIconEdit);
export default __webpack_public_path__ + "static/media/teamsIconEdit.3f11197f081c8de1de9facaa61d1a58e.svg";
export { ForwardRef as ReactComponent };